import { PermissionConfig } from '@surgetech-eu/core'
import { accessDam, accessDamContent, accessDamLogActivity, accessDamPop } from './rights.resolver'

export const DamPermissionsMap: PermissionConfig[] = [
  {
    urlMasks: ['/dam/administration/*', '/dam/master-image', '/dam/3d-management'],
    menuItemNames: ['administration', 'master-image', '3d-management'],
    requiredAction: 'uploadDamMedia'
  },
  {
    urlMasks: '/dam/users',
    menuItemNames: 'dam-users',
    requiredAction: 'manageDamUsers'
  },
  {
    urlMasks: ['/dam/product-images'],
    menuItemNames: ['dam', 'product-images'],
    requiredAction: accessDam
  },
  {
    urlMasks: ['/dam/contents'],
    menuItemNames: ['contents'],
    requiredAction: accessDamContent
  },
  {
    urlMasks: ['/dam/log-activities-product-images'],
    menuItemNames: ['log-activities-product-images'],
    requiredAction: accessDamLogActivity
  },
  {
    urlMasks: ['/dam/log-activities-contents'],
    menuItemNames: ['log-activities-contents'],
    requiredAction: accessDamLogActivity
  },
  {
    urlMasks: ['/dam/pop-images'],
    menuItemNames: ['pop-images'],
    requiredAction: accessDamPop
  }
]
